package com.xtream.video_player

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.viewinterop.HtmlElementView
import androidx.compose.ui.window.ComposeViewport
import com.xtream.core_model.dto.MovieSubtitle
import com.xtream.video_player.shaka.shakaAddErrorListener
import com.xtream.video_player.shaka.shakaAttach
import com.xtream.video_player.shaka.shakaCreatePlayer
import com.xtream.video_player.shaka.shakaGetAssetUri
import com.xtream.video_player.shaka.shakaInstallPolyfills
import com.xtream.video_player.shaka.shakaIsBrowserSupported
import com.xtream.video_player.shaka.shakaIsReady
import com.xtream.video_player.shaka.shakaLoad
import com.xtream.video_player.shaka.shakaSetReady
import com.xtream.video_player.util.ProjectContentScale
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLVideoElement
import kotlin.js.Promise

fun isWebOS(): Boolean = js("typeof window.webOS !== 'undefined'") as Boolean
fun isTizen(): Boolean = js("typeof window.tizen !== 'undefined'") as Boolean
fun isBrowser(): Boolean = !isWebOS() && !isTizen()
@Composable
actual fun WebPlayer(
    url: String,
    modifier: Modifier,
    title: String?,
    contentScale: ProjectContentScale,
    surfaceType: Int,
    onPlaybackLoadingChange: (currentPosInMillis: Long, durationInMillis: Long) -> Unit,
    onPlaybackEnded: (() -> Unit)?,
    onScreenResizeClicked: () -> Unit,
    onMenuClicked: (() -> Unit)?,
    hideAfterMillis: Long,
    infos: List<String>?,
    progress: Long,
    onPlayerClicked: () -> Unit,
    controllersUI: @Composable ((Boolean, () -> Unit, () -> Unit, () -> Unit) -> Unit)?,
    subtitles: List<MovieSubtitle.Subtitle?>?,
    enableControls: Boolean,
    onNavigationIconClick: () -> Unit
) {
   /* var isLoading by remember { mutableStateOf(true) }
    var showControls by remember { mutableStateOf(true) }

    DisposableEffect(url) {
        console.log("DisposableEffect fired, url: $url")
        console.log("isTizen: ${isTizen()}, isWebOS: ${isWebOS()}, shakaSupported: ${ShakaPlayer.isSupported()}")


        val container = kotlinx.browser.document.getElementById("video-container")
        container?.asDynamic()?.style?.display = "block"

        when {
            isTizen() -> {
                // Samsung AVPlay
               //todo initTizenAVPlay(url)
                isLoading = false

                val interval = kotlinx.browser.window.setInterval({
                    val t = js("window._intvCurrentTime") as? Int ?: 0
                    onPlaybackLoadingChange(t.toLong(), 0L)
                }, 1000)

                onDispose {
                    kotlinx.browser.window.clearInterval(interval)
                   //todo tizenStop()
                    container?.asDynamic()?.style?.display = "none"
                }
            }

            ShakaPlayer.isSupported() -> {
                // LG webOS + modern browsers — Shaka Player
                ShakaPlayer.install("intv-player", url)
                val containerExists = kotlinx.browser.document.getElementById("video-container") != null
                val videoExists = kotlinx.browser.document.getElementById("intv-player") != null
                console.log("container exists: $containerExists, video exists: $videoExists")
                // poll for ready + progress
                val interval = kotlinx.browser.window.setInterval({
                    val ready = js("window._intvShakaReady === true") as? Boolean ?: false
                    if (ready) isLoading = false

                    val currentMs = ShakaPlayer.currentTimeMs()
                    val durationMs = ShakaPlayer.durationMs()
                    if (durationMs > 0) {
                        onPlaybackLoadingChange(currentMs, durationMs)
                    }

                    // ended detection
                    val ended = js("""
                        window._intvVideoElement && 
                        window._intvVideoElement.ended
                    """) as? Boolean ?: false
                    if (ended) onPlaybackEnded?.invoke()
                }, 1000)

                onDispose {
                    kotlinx.browser.window.clearInterval(interval)
                    ShakaPlayer.destroy()
                    container?.asDynamic()?.style?.display = "none"
                }
            }

            else -> {
                // Fallback — HLS.js for older browsers
                val video = kotlinx.browser.document.getElementById("intv-player")
                if (js("typeof Hls !== 'undefined' && Hls.isSupported()") as Boolean) {
                    val hls = js("new Hls({ enableWorker: false })")
                    hls.loadSource(url)
                    hls.attachMedia(video)
                    hls.on(js("Hls.Events.MANIFEST_PARSED"), { _: dynamic, _: dynamic ->
                        video?.asDynamic()?.play()
                        isLoading = false
                    })
                } else {
                    video?.asDynamic()?.src = url
                    video?.asDynamic()?.play()
                    isLoading = false
                }

                val interval = kotlinx.browser.window.setInterval({
                    val currentMs = ((video?.asDynamic()?.currentTime as? Double) ?: 0.0) * 1000
                    val durationMs = ((video?.asDynamic()?.duration as? Double) ?: 0.0) * 1000
                    if (durationMs > 0) onPlaybackLoadingChange(currentMs.toLong(), durationMs.toLong())
                }, 1000)

                onDispose {
                    kotlinx.browser.window.clearInterval(interval)
                    video?.asDynamic()?.pause()
                    video?.asDynamic()?.src = ""
                    container?.asDynamic()?.style?.display = "none"
                }
            }
        }
    }

    // Seek
    LaunchedEffect(progress) {
        if (progress > 0) {
            when {
                isTizen() -> {
                    //todo tizenSeek(progress)
                }
                else -> ShakaPlayer.seekTo(progress)
            }
        }
    }*/

    // Compose overlay
   Box(modifier = modifier.fillMaxSize()) {
       WebVideoPlayer(url)
       // All Compose UI above video
       //NestedComposeViewPort(modifier = Modifier.fillMaxSize()) {
          /* controllersUI?.invoke(
               showControls,
               { },
               { showControls = true },
               { showControls = false }
           )*/


           // This block runs inside the second ComposeViewport
       /*  Box(modifier = Modifier.fillMaxSize()) {
               Button(
                   "TEst",
                   modifier = Modifier.align(Alignment.Center)
               ) {}
           }*/
      // }
    }

}


@OptIn(ExperimentalComposeUiApi::class, ExperimentalWasmJsInterop::class)
@Composable
fun WebVideoPlayer(url: String) {

    HtmlElementView(
        factory = {
            (document.createElement("video") as HTMLVideoElement).apply {
                controls = false
                autoplay = true
                style.apply {
                    width = "100%"
                    height = "100%"
                    display = "block"
                    objectFit = "contain"
                    maxWidth = "100%"
                    boxSizing = "border-box"
                    position = "absolute"
                    asDynamic().zIndex = "1"
                    asDynamic().pointerEvents = "none"
                }

                shakaInstallPolyfills()

                if (shakaIsBrowserSupported()) {
                    val player = shakaCreatePlayer()
                    asDynamic().__shakaPlayer = player

                    MainScope().launch {
                        try {
                            console.log("Shaka: calling attach...")
                            shakaAttach(player, this@apply as JsAny)
                                .unsafeCast<Promise<JsAny>>().await()
                            console.log("Shaka: attach resolved")

                            shakaAddErrorListener(player) { error ->
                                console.error("Shaka error:", error)
                            }

                            shakaSetReady(this@apply as JsAny) // sets el.__shakaReady = true via JS
                            console.log("Shaka: attached and ready")

                        } catch (e: Throwable) {
                            console.error("Shaka attach failed:", e.message)
                        }
                    }
                }
            }
        },
        modifier = Modifier.fillMaxSize(),
        update = { video ->
            video.apply {
                parentElement?.let { parent ->
                    parent.asDynamic().style.zIndex = "0"
                    parent.asDynamic().style.pointerEvents = "none"
                }

                if (url.isEmpty()) return@apply

                val player = asDynamic().__shakaPlayer ?: run {
                    if (src != url) {
                        src = url
                        load()
                        oncanplay = {
                            play().catch { }
                            oncanplay = null
                        }
                    }
                    return@apply
                }

                val videoEl = this as JsAny
                val playerEl = player as JsAny

                if (!shakaIsReady(videoEl)) {
                    MainScope().launch {
                        var waited = 0
                        while (!shakaIsReady(videoEl)) {
                            if (waited > 5000) {
                                console.error("Shaka: attach timeout")
                                return@launch
                            }
                            delay(100)
                            waited += 100
                        }
                        if (shakaGetAssetUri(playerEl) != url) {
                            try {
                                shakaLoad(playerEl, url)
                                    .unsafeCast<Promise<JsAny>>().await()
                                console.log("Shaka: loaded $url")
                            } catch (e: Throwable) {
                                console.error("Shaka load failed:", e)
                            }
                        }
                    }
                } else {
                    if (shakaGetAssetUri(playerEl) != url) {
                        MainScope().launch {
                            try {
                                shakaLoad(playerEl, url)
                                    .unsafeCast<Promise<JsAny>>().await()
                                console.log("Shaka: loaded $url")
                            } catch (e: Throwable) {
                                console.error("Shaka load failed:", e)
                            }
                        }
                    }
                }
            }
        }
    )

    LaunchedEffect(url) {
        println("URL KT: $url")
    }
}
@OptIn(ExperimentalComposeUiApi::class)
@Composable
fun NestedComposeViewPort(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    HtmlElementView<org.w3c.dom.HTMLDivElement>(factory = {
        (document.createElement("div") as HTMLDivElement).apply {
            style.background = "transparent"
            window.requestAnimationFrame {
                ComposeViewport(this) {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .drawBehind {
                                // ✅ This punches a transparent hole through
                                // the white Compose canvas background
                                drawRect(
                                    color = Color.Transparent,
                                    blendMode = BlendMode.Clear,
                                )
                            },
                    ) {
                        content()
                    }
                }
            }
        }
    }, modifier = modifier.fillMaxSize(), update = {}, onRelease = {}, onReset = null)
}